import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type MenuButtonProps = {
  onClick: React.MouseEventHandler<HTMLElement>;
};

function MenuButton({ onClick }: MenuButtonProps) {
  return (
    <button
      aria-label="Spieler einladen"
      className="grid h-9 w-9 place-items-center"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faBars} size="xl" color="white" />
    </button>
  );
}

export default MenuButton;
